/** Provider dispatch UI helpers (Phase J). */

export function formatIncomingOffer(offer) {
  const incoming = offer?.incoming_request || offer?.offer_payload || {};
  return {
    serviceName:
      incoming.service_display_name ||
      incoming.service_label ||
      offer?.service_key ||
      'Service',
    distanceLabel:
      incoming.distance_label ||
      (incoming.distance_km != null ? `${incoming.distance_km} km away` : 'Nearby'),
    durationDisplay: incoming.duration_display || incoming.duration_label || null,
    caseTypeDisplay: incoming.case_type_display || null,
    baseServiceAmount: incoming.base_service_amount,
    travelAmount: incoming.travel_amount,
    isLongDuration: Boolean(incoming.is_long_duration),
    expiresAt: incoming.expires_at || offer?.expires_at,
  };
}

export function formatProviderAvailability(status) {
  const map = {
    available: { label: 'Available', desc: 'Ready for requests' },
    busy: { label: 'Busy', desc: 'On an active booking' },
    offline: { label: 'Offline', desc: 'Unavailable' },
  };
  return map[status] || { label: status || 'Unknown', desc: '' };
}

export const PROVIDER_OFFER_POLL_MS = 5000;

export async function fetchActiveProviderOffers(client) {
  const { data } = await client.get('/providers/me/offers', { params: { status: 'pending' } });
  const pending = data.offers || [];
  const { data: viewed } = await client.get('/providers/me/offers', { params: { status: 'viewed' } });
  return [...pending, ...(viewed.offers || [])];
}

export function pickNewestActiveOffer(offers) {
  if (!Array.isArray(offers) || offers.length === 0) return null;
  return offers[0];
}

export function canSelectAvailability(provider, targetStatus) {
  if (!provider) return false;
  if (targetStatus === 'available' && (provider.has_active_booking || provider.financial_locked)) return false;
  if (provider.availability_status === 'busy' && provider.has_active_booking) {
    return targetStatus === 'offline';
  }
  return true;
}
